<fieldset class="py-3 mb-3">
    <mat-tab-group>
    <mat-tab label="Plan Detail">
        <div>
            <fieldset class="mt-3">
                <legend>Expected Training Cost Details</legend>
                <div class="grid grid-cols-2 gap-4">
                    <div class="col-span-2">
                        <table class="table-auto budget-table mt-2">
                            <tbody>
                                <tr>
                                    <td class="cost-left w-20">Organizing Committee</td>
                                    <td class="bg-white" colspan="4"></td>
                                </tr>
                                <tr>
                                    <td class="cost-left">Committee Member</td>
                                    <td class="bg-white"></td>
                                    <td class="cost-left w-20">Training ID</td>
                                    <td class="bg-white" colspan="2"></td>
                                </tr>

                                <tr>
                                    <td class="cost-left">Training Title</td>
                                    <td class="bg-white" colspan="4"></td>
                                    
                                </tr>
                                <tr>
                                    <td class="cost-left">Duration</td>
                                    <td class="bg-white"></td>
                                    <td class="cost-left">Residential</td>
                                    <td class="bg-white" colspan="2"></td>
                                </tr>
                                <tr>
                                    <td class="cost-left">Venue</td>
                                    <td class="bg-white w-30"></td>
                                    <td class="cost-left">Duration Days</td>
                                    <td class="bg-white" colspan="2"></td>
                                </tr>

                                <tr>
                                    <td class="cost-left">As Per Approved Plan</td>

                                    <td class="cost-left">Trainee</td>
                                    <td class="bg-white"></td>

                                    <td class="cost-left w-20">Resource Person</td>
                                    <td class="bg-white w-10"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <table class="cost-table">
                        <tr>
                            <td colspan="2" class="td-title">
                            Expected Training Cost (As per Plan Approved)
                            </td>
                        </tr>

                        <tr>
                            <td class="completion-leftsec">Training Cost : For 32 participants</td>
                            <td class="amount">14400/-</td>
                        </tr>

                        <tr>
                            <td class="completion-leftsec">Honorarium Cost :</td>
                            <td class="amount">1950/-</td>
                        </tr>

                        <tr class="total-row">
                            <td class="completion-leftsec">Total</td>
                            <td class="amount">16350/-</td>
                        </tr>
                    </table>

                    <table class="cost-table">
                        <tr>
                            <td colspan="2" class="td-title">
                                Expected Training Cost (As per Completion)
                            </td>
                        </tr>

                        <tr>
                            <td class="completion-leftsec">Training Cost : For 32 participants</td>
                            <td class="amount">14400/-</td>
                        </tr>

                        <tr>
                            <td class="completion-leftsec">Honorarium Cost :</td>
                            <td class="amount">1950/-</td>
                        </tr>

                        <tr class="total-row">
                            <td class="completion-leftsec">Total</td>
                            <td class="amount">16350/-</td>
                        </tr>
                    </table>
                </div>
            </fieldset>
        </div>
        <mat-accordion>
            <mat-expansion-panel expanded="true" (opened)="panelOpenState.set(true)"
                (closed)="panelOpenState.set(false)" class="expand-margin">
                <mat-expansion-panel-header>
                    <mat-panel-title> 
                        <div class="flex flex-row gap-x-3 w-100">
                            <div class="border-r border-sky-500 pr-3" style="width: 20%;">
                                <span class="font-medium">Day 1 - 24/12/2025</span>
                            </div>
                            <div class="text-center" style="width: 80%;">
                                <span class="font-medium">Participant Details</span>
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <fieldset class="pt-2">
                        <!--participant-details-->
                        <div class="participant-details">
                        <table>
                            <thead>
                                <tr>
                                    <th>GP Name</th>
                                    <th>Village Name </th>
                                    <th>SHG Name</th>
                                    <th>Member Name</th>
                                    <th>Contact</th>
                                    <th>Cbo Type</th>
                                    <th>Attn</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                            </tbody>
                        </table>


                        </div>
                    </fieldset>
                </div>

                <div class="pt-2">
                    <fieldset class="pt-2">
                        <div class="grid grid-cols-4 gap-4">
                            <div class="attachment-view">
                                <div class="view-file">Food</div>

                                <div class="grid grid-cols-2 gap-2 mt-3">
                                    <button class="signin">
                                        <span class="material-symbols-outlined">visibility</span>
                                    </button>
                                    <button class="button-sec">
                                        <span class="material-symbols-outlined">download</span>
                                    </button>
                                </div>
                            </div>

                            <div class="attachment-view">
                                <div class="view-file">Training Material</div>

                                <div class="grid grid-cols-2 gap-2 mt-3">
                                    <button class="signin">
                                        <span class="material-symbols-outlined">visibility</span>
                                    </button>
                                    <button class="button-sec">
                                        <span class="material-symbols-outlined">download</span>
                                    </button>
                                </div>
                            </div>

                            <div class="attachment-view">
                                <div class="view-file">Environment</div>

                                <div class="grid grid-cols-2 gap-2 mt-3">
                                    <button class="signin">
                                        <span class="material-symbols-outlined">visibility</span>
                                    </button>
                                    <button class="button-sec">
                                        <span class="material-symbols-outlined">download</span>
                                    </button>
                                </div>
                            </div>

                            <div class="attachment-view">
                                <div class="view-file">Attendance Files</div>

                                <div class="grid grid-cols-2 gap-2 mt-3">
                                    <button class="signin">
                                        <span class="material-symbols-outlined">visibility</span>
                                    </button>
                                    <button class="button-sec">
                                        <span class="material-symbols-outlined">download</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>

            </mat-expansion-panel>


            <mat-expansion-panel (opened)="panelOpenState.set(true)"
                (closed)="panelOpenState.set(false)" class="expand-margin">
                <mat-expansion-panel-header>
                    <mat-panel-title> 
                        <div class="flex flex-row gap-x-3 w-100">
                            <div class="border-r border-sky-500 pr-3" style="width: 20%;">
                                <span class="font-medium">Day 2 - 04/2/2025</span>
                            </div>
                            <div class="text-center" style="width: 80%;">
                                <span class="font-medium">Participant Details</span>
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <fieldset class="pt-2">
                        <!--participant-details-->
                        <div class="participant-details">
                        <table>
                            <thead>
                                <tr>
                                    <th>GP Name</th>
                                    <th>Village Name </th>
                                    <th>SHG Name</th>
                                    <th>Member Name</th>
                                    <th>Contact</th>
                                    <th>Cbo Type</th>
                                    <th>Attn</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                                <tr>
                                <td>BODAI</td>
                                <td>DANGATANGA TANGI </td>
                                <td>TORSA SHG(32020136672)</td>
                                <td>RONIMA KHATUN(320000000000)</td> 
                                <td>0</td>
                                <td>SHG</td>
                                <td>3</td> 
                                </tr>
                            </tbody>
                        </table>


                        </div>
                    </fieldset>
                </div>

                <div class="pt-2">
                    <fieldset class="pt-2">
                        <div class="grid grid-cols-4 gap-4">
                            <div class="attachment-view">
                                <div class="view-file">Food</div>

                                <div class="grid grid-cols-2 gap-2 mt-3">
                                    <button class="signin">
                                        <span class="material-symbols-outlined">visibility</span>
                                    </button>
                                    <button class="button-sec">
                                        <span class="material-symbols-outlined">download</span>
                                    </button>
                                </div>
                            </div>

                            <div class="attachment-view">
                                <div class="view-file">Training Material</div>

                                <div class="grid grid-cols-2 gap-2 mt-3">
                                    <button class="signin">
                                        <span class="material-symbols-outlined">visibility</span>
                                    </button>
                                    <button class="button-sec">
                                        <span class="material-symbols-outlined">download</span>
                                    </button>
                                </div>
                            </div>

                            <div class="attachment-view">
                                <div class="view-file">Environment</div>

                                <div class="grid grid-cols-2 gap-2 mt-3">
                                    <button class="signin">
                                        <span class="material-symbols-outlined">visibility</span>
                                    </button>
                                    <button class="button-sec">
                                        <span class="material-symbols-outlined">download</span>
                                    </button>
                                </div>
                            </div>

                            <div class="attachment-view">
                                <div class="view-file">Attendance Files</div>

                                <div class="grid grid-cols-2 gap-2 mt-3">
                                    <button class="signin">
                                        <span class="material-symbols-outlined">visibility</span>
                                    </button>
                                    <button class="button-sec">
                                        <span class="material-symbols-outlined">download</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>

            </mat-expansion-panel>
        </mat-accordion>

    </mat-tab>



    <mat-tab label="Assessment">
        <app-feedback-submission></app-feedback-submission>
       
    </mat-tab>
    </mat-tab-group>
</fieldset>